module.exports = __webpack_public_path__ + "static/media/calibri-bold.352f8b00.ttf";